import { selectors } from 'data'
import { StateType } from 'data/types'
import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import EUR from './EUR'
import GBP from './GBP'
import RUB from './RUB'
import TRY from './TRY'
import USD from './USD'

type Props = { className?: string; currency: string; size?: string }

const StyledImg = styled.img<{ size?: string }>`
  width: ${(p) => p.size ?? '2rem'};
  height: ${(p) => p.size ?? '2rem'};
`

const FALLBACK_IMG = `/unknown-currency.svg`

const HOSTED_CURRENCIES = {
  EUR,
  GBP,
  RUB,
  TRY,
  USD
}

const CurrencyLogo = ({ className, currency, size }: Props) => {
  const currencyData = useSelector((state: StateType) =>
    selectors.currencies.getCurrency(state, currency)
  )

  if (HOSTED_CURRENCIES[currency]) {
    const SVGComponent = HOSTED_CURRENCIES[currency]
    return <SVGComponent className={className} size={size} />
  }
  const url = currencyData ? currencyData?.type.logoPngUrl : FALLBACK_IMG
  return <StyledImg alt={`${currency} logo`} className={className} size={size} src={url} />
}

export default CurrencyLogo
